import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class AssigneeModel extends BaseModel {
  @attr("string") name;
  @attr("string") role;
}
